/* <sticky-atc> — mobile sticky add-to-cart bar. Shows once the main buy form
   scrolls out of view; its button re-submits the real product form. */
class StickyAtc extends HTMLElement {
  constructor() {
    super();
    this.section = this.dataset.section;
    this.querySelector("[data-sticky-add]")?.addEventListener("click", () => {
      const form = document.getElementById(`product-form-${this.section}`);
      if (form?.requestSubmit) form.requestSubmit();
      else form?.querySelector('[type="submit"]')?.click();
    });

    const target = document.getElementById(`product-form-${this.section}`);
    if ("IntersectionObserver" in window && target) {
      const io = new IntersectionObserver(
        (entries) => entries.forEach((en) => (this.hidden = en.isIntersecting || en.boundingClientRect.top > 0)),
        { rootMargin: "0px 0px -40% 0px" }
      );
      io.observe(target);
    } else {
      this.hidden = false;
    }
  }
}
if (!customElements.get("sticky-atc")) customElements.define("sticky-atc", StickyAtc);
